<template>
    <!-- 物流管理页面 -->
      <div>
        <div v-show="workShow === 'list'">
          <div class="platformSearch" style="margin-left:10px;">
            <Form :model="pageParams">
              <Row>
                <Col span="6">
                  <Form-item :label="$t('common.accessTimeRange') + '：'">
                    <DatePicker v-model="accessTimeRange" type="daterange" @on-change="handleDateChange" placement="bottom-end" placeholder="请选择时间访问" style="width: 200px" />
                  </Form-item>
                </Col>
                <Col span='3'>
                  <Button type="primary" v-once icon="search" @click="logisSearch">{{$t('common.search')}}</Button>
                </Col>
              </Row>
            </Form>
          </div>
          <Menu mode="horizontal" :theme="theme" :active-name="showStyle" @on-select="changeMenu">
            <MenuItem name="1">
              <Icon type="ios-pie" />
                图表
            </MenuItem>
            <MenuItem name="2">
              <Icon type="ios-list" />
                列表
            </MenuItem>
          </Menu>
          <div v-show="showStyle === '1'">
            <div id="myChart" :style="{width: '1500px', height: '600px'}"></div>
          </div>
          <Row v-show="showStyle === '2'">
            <Col >
            <div class="custom">
                <!-- 物流商 -->
                <dTable highlight-row :columns="accessStatisticsColumns" :data="accessStatisticsData" :height="tableHeight"  style="cursor:pointer;"></dTable>
            </div>
            </Col>
          </Row>
          <div class="pageChange fr">
            <Page :total="accessStatisticsTotal" @on-change="channelChangePage" show-total :page-size="pageParams.pageSize" show-elevator :current="pageParams.pageNum" show-sizer @on-page-size-change="channelChangePageSize" placement="top" :page-size-opts="pageArray"></Page>
          </div>
        </div>
        <!-- 编辑账号 -->
        <accessStatisticsDetail v-if="workShow === 'detail'" :accessStatisticsId="accessStatisticsId" :selectAccessTime="selectAccessTime" :selectTotalTimes="selectTotalTimes"></accessStatisticsDetail>
      </div>
    </template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import accessStatisticsDetail from './accessStatisticsDetail';
export default {
  mixins: [ Mixin, tableMixin ],
  components: {
    accessStatisticsDetail
  },
  data () {
    let self = this;
    return {
      workShow: 'list',
      showStyle: '1', // 显示风格 1-图表 2-列表
      accessStatisticsId: '',
      selectAccessTime: '',
      selectTotalTimes: 0,
      accessTimeRange: [],
      pageParams: {
        pageSize: 20,
        pageNum: 1,
        accessTimeFrom: '', // 访问开始时间
        accessTimeTo: '' // 访问结束时间
      },
      accessStatisticsColumns: [
        {
          title: self.t('common.accessTime'),
          align: 'center',
          key: 'accessTime'
        },
        {
          title: self.t('common.totalTimes') + '/天',
          align: 'center',
          key: 'totalTimes'
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  float: 'left'
                },
                on: {
                  click: () => {
                    let date = new Date().getTime();
                    self.timestamp = date;
                    self.$nextTick(function () {
                      self.workShow = 'detail';
                      self.accessStatisticsId = params.row.accessStatisticsId;
                      self.selectAccessTime = params.row.accessTime;
                      self.selectTotalTimes = params.row.totalTimes;
                    });
                  }
                }
              }, self.t('common.examine'))
            ]);
          }
        }
      ],
      carrierList: [],
      accessStatisticsData: [],
      accessStatisticsTotal: 0,
      myChart: null,
      dateArr: [],
      legendData: [],
      seriesAry: [],
      posList: [
        'left',
        'right',
        'top',
        'bottom',
        'inside',
        'insideTop',
        'insideLeft',
        'insideRight',
        'insideBottom',
        'insideTopLeft',
        'insideTopRight',
        'insideBottomLeft',
        'insideBottomRight'
      ]
    };
  },
  methods: {
    getList () {
      let v = this;
      v.seriesAry = [];
      var obj = {
        pageSize: v.pageParams.pageSize,
        pageNum: v.pageParams.pageNum,
        accessTimeFrom: v.pageParams.accessTimeFrom, //
        accessTimeTo: v.pageParams.accessTimeTo
      };
      v.axios.post(api.accessStatistics_list, obj) // 获取物流商列表
        .then(response => {
          if (response.data.code === 0) {
            v.seriesAry = [];
            v.dateArr = [];
            v.legendData = [];
            v.accessStatisticsData = response.data.datas.list;
            v.accessStatisticsData.forEach(item => {
              item.accessTime = v.convertedDate(item.accessTime);
              // console.log(item.partnerId+","+item.carrierName+","+item.accessTime+","+item.totalTimes);
              if (v.legendData.indexOf(item.carrierName) === -1) {
                v.legendData.push(item.carrierName);
                let series = v.initSeries(item.carrierName, item.partnerId);
                v.seriesAry.push(series);
              }
              if (v.dateArr.indexOf(item.accessTime) === -1) {
                v.dateArr.push(item.accessTime);
              }
            });
            v.accessStatisticsData.forEach(item => {
              v.pushSeriesData(item.partnerId, item.totalTimes);
            });
            // console.log(v.seriesAry);
            v.accessStatisticsTotal = response.data.datas.total;
            if (!v.myChart) {
              v.initChart();
            }
            v.updateChartData();
          } else {
            v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
          }
        });
    },
    // 访问列表查询
    logisSearch () {
      let v = this;
      v.pageParams.pageNum = 1; // 页码重置为1
      v.getList();
    },
    channelChangePage (page, plat) { // 分页切换
      let v = this;
      v.pageParams.pageNum = page;
      v.getList();
    },
    channelChangePageSize (pageSize, plat) {
      let v = this;
      v.pageParams.pageSize = pageSize;
      v.pageParams.pageNum = 1;
      v.getList();
    },
    handleDateChange (dateArray) {
      let v = this;
      console.log('Date range:', dateArray); // ['2025-06-10', '2025-06-17']
      v.pageParams.accessTimeFrom = dateArray[0] + ' 00:00:00';
      v.pageParams.accessTimeTo = dateArray[1] + ' 23:59:59';
    },
    convertedDate (dateStr) { // 转化北京时间
      const options = {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };

      let date = new Date(dateStr);
      date.setHours(date.getHours() + 8);

      const formatter = new Intl.DateTimeFormat('zh-CN', options);
      const beijingTimeStr = formatter.format(date);
      return beijingTimeStr;
    },
    initChart () {
      let v = this;
      v.myChart = v.$echarts.init(document.getElementById('myChart'));
    },
    initSeries (carrierName, partnerId) {
      let series = {
        name: carrierName,
        partnerId: partnerId,
        type: 'bar',
        barGap: 0,
        emphasis: {
          focus: 'series'
        },
        label: {
          show: true,
          // formatter: '{c}  {name|{a}}',
          formatter: function (params) {
            // console.log(params);
            // return `<span style="color:black;font-weight:bold;font-size:16px;">${params.value} ${params.category}</span>`;
            return '{colorBlack|' + params.value + '}';
          },
          fontSize: 16,
          position: 'insideBottom',
          color: 'black',
          fontWeight: 'bold',
          distance: 15,
          align: 'left',
          verticalAlign: 'middle',
          rotate: 90,
          rich: {
            name: {},
            colorBlack: {
              color: 'black', // 设置字体颜色为红色
              fontSize: 15, // 可选：设置字体大小
              fontWeight: 'bold'
            }
          }
        },
        data: []
      };
      return series;
    },
    updateChartData () {
      let v = this;
      v.myChart.clear(); // 清空已有内容
      // 绘制图表
      v.myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '18%', // 绘图区从图例之后开始，留出 10% 的空间给图例
          left: '10%',
          right: '10%',
          bottom: '10%',
          containLabel: true // 确保坐标轴标签也被包含在内
        },
        legend: {
          width: 'auto', // 自动适应宽度
          height: 'auto', // 自动适应高度
          itemGap: 15, // 图例项之间的间距
          padding: [10, 20, 10, 20],
          data: v.legendData
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar', 'stack'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: { // 横轴
          type: 'category',
          name: v.t('common.accessTime'),
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          data: v.dateArr
        },
        yAxis: {
          type: 'value',
          name: v.t('common.totalTimes') + '/天'
        },
        series: v.seriesAry
      });
    },
    changeMenu (name) {
      let v = this;
      // console.log("name="+name);
      v.showStyle = name;
      v.getList();
    },
    pushSeriesData (partnerId, totalTimes) {
      let v = this;
      v.seriesAry.forEach(temp => {
        if (temp.partnerId === partnerId) {
          temp.data.push(totalTimes);
        }
      });
    }
  },
  created () {
    let v = this;
    v.tableHeight = this.getTableHeight(300);
    let now = new Date();
    let dateStr = v.getDateTime(now, 'date');
    v.accessTimeRange = [];
    v.accessTimeRange.push(dateStr);
    v.accessTimeRange.push(dateStr);
    v.pageParams.accessTimeFrom = dateStr + ' 00:00:00';
    v.pageParams.accessTimeTo = dateStr + ' 23:59:59';
    v.getList();
  },
  beforeDestroy () {
    if (this.myChart) {
      this.myChart.dispose(); // 组件销毁前释放资源
    }
  },
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/accessStatistics.vue